import { Page } from "@/models/page-models/Page";

export const CreditNoteCreditNoteId: Page = {
  "path": "credit-note/:creditNoteId",
  "name": "Credit Note",
  "props": {
    "data": {
      "title": "Credit Note",
      "printable": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.cnDetails.data.status}},'),==,'Approved')",
      "url": "credit-note/:creditNoteId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "custom_CreditNoteDetails",
                  "variable": "fetchedData.cnDetails.data",
                  "label": "Credit Note Details",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.cnDetails.data}}",
                  "config": {
                    "customerDetailsVariable": "formData.customerDetails.data",
                    "creditNoteReasonsVariable": "fetchedData.creditNoteReasons.data.0.data"
                  }
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Discount/VR CN Orders",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.emptyOrders}}",
                  "items": "fetchedData.emptyOrders",
                  "headers": [
                    {
                      "value": "__key",
                      "text": "#",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.emptyOrders}}))",
                      "width": 40
                    },
                    {
                      "value": "order",
                      "text": "Order #\\n# حزمة",
                      "type": "formula",
                      "formula": "N/A",
                      "width": 70
                    },
                    {
                      "value": "__item.id.product",
                      "text": "Description\\nالتفاصيل",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(CONDITIONAL,fn(LOGICAL,{{fetchedData.cnDetails.data.invoice._id}},>,0),fn(CONCAT,fn(TRANSLATE,{{fetchedData.cnDetails.data.discountType}},en), against INV ,{{fetchedData.cnDetails.data.invoice._id}}),fn(TRANSLATE,{{fetchedData.cnDetails.data.discountType}},en)),\\n,fn(TRANSLATE,{{fetchedData.cnDetails.data.discountType}},ar))",
                      "width": 200
                    },
                    {
                      "value": "__item.id.product.unit.unit2",
                      "text": "Unit\\nالوحدة",
                      "type": "formula",
                      "formula": "N/A",
                      "width": 61
                    },
                    {
                      "value": "__item.quantity",
                      "text": "Quantity\\nالكمية",
                      "type": "formula",
                      "formula": "N/A",
                      "width": 76
                    },
                    {
                      "value": "__item.unitPrice",
                      "text": "Unit Price SAR\\nسعر الوحدة  ر س",
                      "type": "formula",
                      "formula": "N/A",
                      "width": 58
                    },
                    {
                      "value": "__item.value",
                      "text": "Sub Total\\nالمجموع الفرعي",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(DIVIDE,{{fetchedData.cnDetails.data.value}},fn(MULTIPLY,0.01,fn(SUM,100,{{fetchedData.vatPercent}}))))",
                      "width": 110
                    },
                    {
                      "value": "vatRate",
                      "text": "VAT %\\nالضريبة %",
                      "type": "formula",
                      "formula": "{{fetchedData.vatPercent}} %",
                      "width": 79
                    },
                    {
                      "value": "vatValue",
                      "text": "VAT Value\\nقيمة الضريبة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,fn(SUBTRACT,{{fetchedData.cnDetails.data.value}},fn(DIVIDE,{{fetchedData.cnDetails.data.value}},fn(MULTIPLY,0.01,fn(SUM,100,{{fetchedData.vatPercent}})))))",
                      "width": 91
                    },
                    {
                      "value": "total",
                      "text": "Total + VAT\\nالمجموع + الضريبة",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,currency,{{fetchedData.cnDetails.data.value}})",
                      "width": 120
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "footer": {
                    "value": "{{fetchedData.selectedInvoice.data.orders.0.additionalCharges}}",
                    "id.product": "{{fetchedData.selectedInvoice.data.orders.0.additionalChargesType}}"
                  },
                  "fontSize": "0.75rem",
                  "hideFooter": "fn(LOGICAL,{{fetchedData.selectedInvoice.data.orders.0.additionalCharges}},>,0)"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Invoice Orders",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.formattedOrders}}",
                  "items": "fetchedData.formattedOrders",
                  "headers": [
                    {
                      "value": "slNo",
                      "text": "#",
                      "width": 40
                    },
                    {
                      "value": "order",
                      "text": "Order #\\n# حزمة",
                      "width": 70
                    },
                    {
                      "value": "description",
                      "text": "Description\\nالتفاصيل",
                      "width": 200
                    },
                    {
                      "value": "unit",
                      "text": "Unit\\nالوحدة",
                      "width": 61
                    },
                    {
                      "value": "quantity",
                      "text": "Quantity\\nالكمية",
                      "width": 76
                    },
                    {
                      "value": "unitPrice",
                      "text": "Price\\nالسعر",
                      "width": 58
                    },
                    {
                      "value": "subTotal",
                      "text": "Sub Total\\nالمجموع الفرعي",
                      "width": 110
                    },
                    {
                      "value": "vatRate",
                      "text": "VAT %\\nالضريبة %",
                      "width": 79
                    },
                    {
                      "value": "vatValue",
                      "text": "VAT Value\\nقيمة الضريبة",
                      "width": 91
                    },
                    {
                      "value": "total",
                      "text": "Total + VAT\\nالمجموع + الضريبة",
                      "width": 120
                    }
                  ],
                  "tableType": "static",
                  "showActions": false,
                  "fontSize": "0.75rem;"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "custom_InvoiceTotal",
                  "disabled": "FALSE",
                  "config": {
                    "subTotalFormula": "fn(DIVIDE,{{fetchedData.cnDetails.data.value}},fn(MULTIPLY,0.01,fn(SUM,100,{{fetchedData.vatPercent}})))",
                    "totalFormula": "{{fetchedData.cnDetails.data.value}}",
                    "companyDetails": "{{fetchedData.companyDetails.data.0.data}}",
                    "docDetails": "{{fetchedData.cnDetails.data}}",
                    "showQrCode": true,
                    "qrCodeVariable": "fetchedData.cnDetails.data.qr",
                    "vatVariable": "{{fetchedData.vatPercent}}"
                  }
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Notes",
                  "printable": false,
                  "class": "text-subtitle-2"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.cnDetails.data.reason",
                  "label": "Reason",
                  "showIf": "{{fetchedData.cnDetails.data.reason}}",
                  "printable": false,
                  "class": "text-caption"
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.cnDetails.data.invoice._id",
                  "label": "Invoice",
                  "printable": false,
                  "class": "text-caption"
                }
              ]
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "fileupload",
                  "variable": "fetchedData.cnDetails.data.additionalProof",
                  "label": "Additional Proof",
                  "disabled": "TRUE",
                  "showIf": "{{fetchedData.cnDetails.data.additionalProof}}",
                  "printable": false,
                  "class": "text-caption",
                  "previewType": "standard"
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Approve & Clear CN",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.cnDetails.data.status}},'),==,'Submitted'))",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "approveCreditNote",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/invoice-payment/{{fetchedData.cnDetails.data._id}}/approve",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "storeResponse",
                        "arg3Value": "TRUE"
                      },
                      "name": "approveCreditNote"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "showApprovedCnSnackbar",
                        "type": "fnOpenSnackbar",
                        "color": "secondary",
                        "serverMessage": "Credit Note Approved, requesting ZATCA Clearance"
                      },
                      "executeIf": "fn(LOGICAL,{{__response.data._id}},>,0)",
                      "name": "showApprovedCnSnackbar"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "clearCreditNote",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/e-invoicing/clear-invoice/{{fetchedData.cnDetails.data._id}}?type=Credit Note",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "GET"
                      },
                      "name": "clearCreditNote",
                      "executeIf": "fn(LOGICAL,{{__response.data.typeId}},>,0)"
                    }
                  ],
                  "color": "secondary"
                }
              ]
            },
            {
              "name": "10",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Clear Credit Note",
                  "disabled": "FALSE",
                  "showIf": "fn(NOT,{{fetchedData.cnDetails.data.qr}})",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "clearCreditNote",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/e-invoicing/clear-invoice/{{fetchedData.cnDetails.data._id}}?type=Credit Note",
                        "arg2Key": "postData",
                        "arg2Value": "{}",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE",
                        "arg4Key": "requestMethod",
                        "arg4Value": "GET"
                      },
                      "name": "approveCreditNote"
                    }
                  ],
                  "color": "secondary"
                }
              ],
              "showIf": "fn(LOGICAL,fn(LOGICAL,fn(MATCH_ROLE,General Manager),||,fn(MATCH_ROLE,Sales | Manager)),&&,fn(LOGICAL,fn(CONCAT,',{{fetchedData.cnDetails.data.status}},'),==,'Approved'))"            },
            {
              "name": "11",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.cnDetails.data.status}},'),==,'Approved')",
                  "color": "primary",
                  "buttonType": "print"
                }
              ],
              "showIf": "{{fetchedData.cnDetails.data.qr}}"
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true,
      "arabicTitle": "إشعار إضافة",
      "printDocDate": "{{fetchedData.cnDetails.data.createdAt}}"
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCreditNote",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/invoice-payment/{{__params.creditNoteId}}",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.cnDetails"
        },
        "name": "getCreditNote"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCreditNoteReasons",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=credit-note-reasons",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.creditNoteReasons"
        },
        "name": "getCreditNoteReasons"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getCustomerDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers/{{fetchedData.cnDetails.data.customer}}",
          "arg2Key": "storeInVar",
          "arg2Value": "formData.customerDetails"
        },
        "name":"getCustomerDetails"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copyVatPercentage",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getVatPercentage",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name":"copyVatPercentage"
      },
      { 
        "executionOrder": 4,
        "pageFunction": {
          "name": "addEmptyOrders",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getEmptyOrders",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name":"addEmptyOrders",
        "executeIf":"fn(LOGICAL,fn(CONCAT,',{{fetchedData.cnDetails.data.subtype}},'),==,'Customer Discount')"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getInvoiceDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/invoice/{{fetchedData.cnDetails.data.invoice._id}}",
          "arg2Key": "storeInVar",
          "arg2Value": "formData.invoiceDetails"
        },
        "name":"getInvoiceDetails",
        "executeIf":"fn(LOGICAL,fn(CONCAT,',{{fetchedData.cnDetails.data.subtype}},'),!==,'Customer Discount')"
      },
      {
        "executionOrder": 3,
        "pageFunction": {
          "name": "copyReturnedOrders",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getReturnedOrders",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.invoiceDetails",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyReturnedOrders",
        "executeIf": "fn(LOGICAL,fn(CONCAT,',{{fetchedData.cnDetails.data.subtype}},'),==,'Returned Item')"
    },
    {
        "executionOrder": 4,
        "pageFunction": {
          "name": "copyFormattedOrders",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getFormattedOrders",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyFormattedOrders"
    }
    ],
    "functions": [
      {
        "name": "getEmptyOrders",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "emptyOrders": "[{}]"
        },
        "useFormula": true
      },
      {
        "name": "getVatPercentage",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "vatPercent": "fn(CONDITIONAL,{{formData.customerDetails.data.exportCustomer}},0,{{fetchedData.companyDetails.data.0.data.vatPercentage}})"
        },
        "useFormula": true
      },
      {
        "name": "getFormattedOrders",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "formattedOrders": "fn(HELPER_FN,formatOrderForInvoice,{{formData.invoiceDetails.data}},{{fetchedData.vatPercent}})"
        },
        "useFormula": true
      },
      {
        "name": "getReturnedOrders",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "data": "fn(HELPER_FN,ordersArrayForReturnItem,{{formData.invoiceDetails.data}},{{fetchedData.cnDetails.data}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,GENERAL_MANAGER",
  "visible": false,
  "routerPriority": 100
}